import { useEffect } from "react";
var usePullUp = function () {
    useEffect(function () {
        window.scrollTo(0, 0);
    }, []);
};
export default usePullUp;
//# sourceMappingURL=usePullUp.js.map